import styled from 'styled-components';
import { baseSelectItem, Flex, gridSizes } from 'utils/style';

import SuggestedItem from 'components/form/SuggestedTimes/SuggestedItem/container';

// TODO  extract the height of the cell
export default styled(SuggestedItem)`
  ${baseSelectItem}
  ${Flex.row};
  height: 32px;
  align-items: center;
  padding: 0 ${gridSizes('S')};
  color: var(--grey900);
  text-decoration: none;
  width: 100%;
`;
